import { render, staticRenderFns } from "./FormaRecebimentoManage.vue?vue&type=template&id=eed1f064&scoped=true"
import script from "./FormaRecebimentoManage.vue?vue&type=script&lang=js"
export * from "./FormaRecebimentoManage.vue?vue&type=script&lang=js"
import style0 from "./FormaRecebimentoManage.vue?vue&type=style&index=0&id=eed1f064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed1f064",
  null
  
)

export default component.exports